// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"132":"27feb969","149":"5e255950","207":"946382a7","367":"57a447dc","421":"c7e90569"}[chunkId] + ".chunk.js";
};